// extracted by mini-css-extract-plugin
export default {"root":"Form_root__osetn","row":"Form_row__Ob3vr","half":"Form_half__grKS-","select":"Form_select__JMoED","quarter":"Form_quarter__LsY6Y"};